// Reused windows slots can retain their closed state when the reactive open
// pass is skipped. Restore the host properties that control layout, paint and
// hit-testing without raising CSS specificity.
export const restoreOpenModalLayer = (layerId) => {
  const root = globalThis.__SMBLS_WINDOWS_MODAL_ROOT__
  const stack = root?.state?.stack || []
  const index = stack.findIndex((layer) => layer?.id === layerId)
  if (index < 0) return
  const slot = root?.['ModalLayer_' + index]
  const node = slot?.node || slot?.__ref?.node
  if (!node?.style?.setProperty) return
  node.style.setProperty('display', 'flex')
  node.style.setProperty('opacity', '1')
  node.style.setProperty('visibility', 'visible')
  node.style.setProperty('pointer-events', 'auto')
}

// Read-only dialogs have no meaningful initial control. Suppress only the
// windows host's deferred initial focus; after two frames the normal focus
// trap and keyboard navigation resume unchanged.
export const suppressInitialModalFocus = (layerId) => {
  if (typeof document === 'undefined') return
  const titleId = 'modal-title-' + layerId
  const onFocus = (event) => {
    const dialog = event.target?.closest?.(`[aria-labelledby="${titleId}"]`)
    if (dialog) event.target.blur?.()
  }
  document.addEventListener('focusin', onFocus, true)

  const schedule =
    typeof requestAnimationFrame === 'function'
      ? requestAnimationFrame
      : (callback) => setTimeout(callback, 0)
  schedule(() => schedule(() => document.removeEventListener('focusin', onFocus, true)))
}
